import { Box, Typography } from '@mui/material';
import React from 'react';

export interface IMobileValueRowProps {
  caption: React.ReactNode;
  children: React.ReactNode;
}

export const MobileValueRow = ({ caption, children }: IMobileValueRowProps) => {
  return (
    <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
      <Typography variant="secondary14" color="text.secondary">
        {caption}
      </Typography>
      <Typography variant="secondary14">
        {children}
      </Typography>
    </Box>
  );
};
